module.exports = "<partners-table id=\"partnersRoot\"></partners-table>";